import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import Projets from "@/pages/Projets";

export const Route = createFileRoute("/projets")({
  head: () =>
    routeHead({
      path: '/projets',
      title: "Projets | Portfolio architecture d'intérieur Lyon",
      description: "Les réalisations de JIIA Studio : architecture d'intérieur, rénovation et images 3D à Lyon et dans l'Ouest lyonnais.",
    }),
  component: Projets,
});
